import React from 'react';
import { Formik, Field, Form } from 'formik';
import * as Yup from 'yup';
// import { TextField, CheckboxWithLabel } from 'formik-material-ui';
import Dropzone from './Dropzone';

// Material UI
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

const addSchema = Yup.object().shape({
  name: Yup.string(),
  global: Yup.bool().default(false).required('Required'),
});

const AddAsset = ({ isOpen, onClose, onAssetAdded }) => {
  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth>
      <Formik
        initialValues={{ name: '', global: false }}
        validationSchema={addSchema}
        onSubmit={(values, actions) => {
          setTimeout(() => {
            alert(JSON.stringify(values, null, 2));
            actions.setSubmitting(false);
          }, 400);
        }}
        render={({ isSubmitting, handleSubmit }) => (
          <div>
            <DialogTitle>Add Asset</DialogTitle>
            <DialogContent>
              <Form>
                <Field
                  autoFocus
                  type="text"
                  name="name"
                  label="Name"
                  // component={TextField}
                  margin="normal"
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                <Field
                  name="global"
                  Label={{ label: 'Global asset?' }}
                  // component={CheckboxWithLabel}
                />
                <Dropzone
                  dropText="Drop your assets here or click to select"
                  accept={
                    'video/3gpp, video/mp4, video/mpeg, video/ogg, ' +
                    'video/quicktime, video/webm, video/x-m4v, ' +
                    'video/ms-asf, video/x-ms-wmv, video/x-msvideo, ' +
                    'audio/basic, auido/L24, audio/mid, audio/mpeg, ' +
                    'audio/mp4, audio/x-aiff, audio/x-mpegurl, ' +
                    'audio/vnd.rn-realaudio, audio/ogg, audio/vorbis, ' +
                    'audio/vnd.wav, audio/mp3'
                  }
                  handleAddFile={() => {
                    console.log('handleAddFile');
                  }}
                  handleErrorMessage={message => {
                    console.log('handleErrorMessage', message);
                  }}
                  handleCancel={() => {
                    console.log('handleCancel');
                  }}
                />
              </Form>
            </DialogContent>
            <DialogActions>
              <Button disabled={isSubmitting} onClick={handleSubmit} color="primary">
                Add
              </Button>
              <Button onClick={onClose} color="primary">
                Cancel
              </Button>
            </DialogActions>
          </div>
        )}
      />
    </Dialog>
  );
};

export default AddAsset;
